import { Heart, Lightbulb, Brain, type LucideIcon } from 'lucide-react';
import { categoryTranslationMap, CategoryType } from 'types/tracking';
import { normalize } from 'utils/common';

export const DEFAULT_SURVEY_TAG = 'otro';

type CategoryConfig = {
  icon: LucideIcon;
  titleKey: string;
  colors: { bg: string; text: string };
};

const categoryConfigMap: Record<CategoryType, CategoryConfig> = {
  [CategoryType.HEALTHY_HABITS]: {
    icon: Heart,
    titleKey: 'WellBeing.Test.Categories.healthyHabits',
    colors: { bg: 'bg-pink-50', text: 'text-pink-500' },
  },
  [CategoryType.COMPETENCIES]: {
    icon: Lightbulb,
    titleKey: 'WellBeing.Test.Categories.competencies',
    colors: { bg: 'bg-blue-100', text: 'text-blue-600' },
  },
  [CategoryType.MENTAL_HEALTH]: {
    icon: Brain,
    titleKey: 'WellBeing.Test.Categories.mentalHealth',
    colors: { bg: 'bg-purple-100', text: 'text-purple-600' },
  },
  [CategoryType.RELATIONAL_HEALTH]: {
    icon: Brain,
    titleKey: 'WellBeing.Test.Categories.relationalHealth',
    colors: { bg: 'bg-green-100', text: 'text-green-600' },
  },
  [CategoryType.PROFESSIONAL_FULFILLMENT]: {
    icon: Lightbulb,
    titleKey: 'WellBeing.Test.Categories.professionalFulfillment',
    colors: { bg: 'bg-orange-100', text: 'text-orange-600' },
  },
  [CategoryType.OTHER]: {
    icon: Brain,
    titleKey: 'WellBeing.Test.Categories.other',
    colors: { bg: 'bg-gray-100', text: 'text-gray-600' },
  },
};

const getCategoryType = (tag: string): CategoryType => {
  const normalizedTag = normalize(tag);
  return categoryTranslationMap[normalizedTag] ?? CategoryType.OTHER;
};

const getCategoryConfig = (tag: string): CategoryConfig => {
  const categoryType = getCategoryType(tag);
  return categoryConfigMap[categoryType];
};

export const getTagIcon = (tag: string): LucideIcon => getCategoryConfig(tag).icon;
export const getTagTitleKey = (tag: string): string => getCategoryConfig(tag).titleKey;
export const getTagIconColor = (tag: string): { bg: string; text: string } =>
  getCategoryConfig(tag).colors;
